// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3WSFF","dragIcon":"Choice_dragIcon__2Ppuj","left":"Choice_left__3mIlY","input":"Choice_input__1qh5r"};